import { WMSFeatureInfoParams } from "src/services/ogc.service";
import { WMSOverlayer } from "src/types";

export function parseWMSFeatureInfoParams(
  event: L.LeafletMouseEvent
): Pick<WMSFeatureInfoParams, "x" | "y" | "width" | "height" | "bbox"> {
  // round containerPoints for specific browsers (e.g. Chrome specific version)
  const x = Math.round(event.containerPoint.x);
  const y = Math.round(event.containerPoint.y);

  const { x: width, y: height } = event.target._size;

  const bounds = event.target.getBounds(); //.toBBoxString();
  const bbox = `${bounds.getSouthWest().lng},${bounds.getSouthWest().lat},${bounds.getNorthEast().lng},${
    bounds.getNorthEast().lat
  }`;

  return { x, y, width, height, bbox };
}

export function legendGraphicUrl(layer: WMSOverlayer): string {
  const params = new URLSearchParams();
  params.set("version", "1.1.0");
  params.set("request", "GetLegendGraphic");
  params.set("layer", layer.layers);
  // @ts-ignore
  params.set("format", "image/png");
  params.set("style", layer.style || layer.styles || layer.params?.styles || "");

  return `${layer.url}?${params.toString()}`;
}
